import React from "react";
import FormLabelFieldPreview from "../form-label-field-preview/FormLabelFieldPreview";
import FormValueFieldPreview from "../form-value-field-preview/FormValueFieldPreview";

const FormFieldPreview = props => {
  const {number, label, value} = props;

  return (
    <div className="d-block w-100 mb-3">
      <FormLabelFieldPreview label={label} number={number} className="mb-1" />
      <FormValueFieldPreview value={value} />
    </div>
  );
};

export default FormFieldPreview;
